import { render, staticRenderFns } from "./PetAndProjectTransactionsTabComponent.vue?vue&type=template&id=62887e0e&scoped=true&"
import script from "./PetAndProjectTransactionsTabComponent.vue?vue&type=script&lang=js&"
export * from "./PetAndProjectTransactionsTabComponent.vue?vue&type=script&lang=js&"
import style0 from "./PetAndProjectTransactionsTabComponent.vue?vue&type=style&index=0&id=62887e0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62887e0e",
  null
  
)

export default component.exports